<template>
    <div class="NoDataFound">
        <div style="text-align: center; font-size: 14px; font-weight: 600; color: #e29d5a; padding: 15px;">
            No data available
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoDataFound"
    }
</script>
